import { defaultDateISO8601 } from 'models/utils/isoDate'
import { IntervalDTO, Schema, SchemaAndIntervals } from 'models/schema'

import {
  auctionLightTableLabels,
  futureAuctionVehiclesTableLabels,
  futureSalesTableLabels,
  historyTableLabels,
  saleResultVehiclesTableLabels,
  searchResultTableLabels,
  stockPageTableLabels,
  waitingFilesPageTableLabels,
} from 'utils/labels'

const defaultInterval: IntervalDTO = {
  userId: '',
  schemaId: '',
  tableName: 'futureSales',
  executionSchedule: {
    frequency: 0,
    executionTime: '12:00:00',
    specificDays: [0],
    startDate: defaultDateISO8601,
    endDate: defaultDateISO8601,
  },
  isActive: false,
}

const defaultSchema: Schema = {
  userId: '',
  email: '',
  companyId: '',
  type: 'ExternalUser',
  tableMappings: [
    { tableName: 'futureSales', customizations: futureSalesTableLabels },
    { tableName: 'futureSalesDetail', customizations: futureAuctionVehiclesTableLabels },
    { tableName: 'waitingFiles', customizations: waitingFilesPageTableLabels },
    { tableName: 'salesResult', customizations: auctionLightTableLabels },
    { tableName: 'salesResultDetail', customizations: saleResultVehiclesTableLabels },
    { tableName: 'stock', customizations: stockPageTableLabels },
    { tableName: 'search', customizations: searchResultTableLabels },
    { tableName: 'history', customizations: historyTableLabels },
  ],
}
const defaultIntervals: Array<IntervalDTO> = [
  { ...defaultInterval, tableName: 'futureSales' },
  { ...defaultInterval, tableName: 'waitingFiles' },
  { ...defaultInterval, tableName: 'salesResult' },
  { ...defaultInterval, tableName: 'stock' },
]

const defaultSchemaAndIntervals: SchemaAndIntervals = {
  schema: defaultSchema,
  intervals: defaultIntervals,
}

export { defaultSchema, defaultInterval, defaultSchemaAndIntervals, defaultIntervals }
